import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    message: '',
    frequency: 1,
    delay: 0,
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    layout: 'feed',
  },
  itemDesign: {},
  containerDesign: {},
};

export const welcomeSlice = createSlice({
  name: 'welcome',
  initialState,
  reducers: {
    welcomeStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        message: blockContent.message ?? '',
        frequency: blockContent.frequency ?? 1,
        delay: blockContent.delay ?? 0,
        // heading: {
        //   title: blockContent.heading.title ?? '',
        //   description: blockContent.heading.description ?? '',
        //   textAlign: blockContent.heading.textAlign ?? 'left',
        //   image: blockContent.heading.image ?? '',
        //   divider: blockContent.heading.divider ?? '',
        //   position: blockContent.heading.position ?? '',
        // },
      };
      state.blockDesign = {
        layout: blockDesign.layout ?? 'feed',
      };
    },
    welcomeClear: () => initialState,

    welcomeUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    welcomeUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    welcomeUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    welcomeUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { welcomeStore, welcomeClear, welcomeUpdateIsLoading, welcomeUpdateIsActive, welcomeUpdateBlockContent, welcomeUpdateBlockDesign } = welcomeSlice.actions;

export const selectWelcomeIsLoading = (state) => state.welcome.isLoading;
export const selectWelcomeIsActive = (state) => state.welcome.isActive;

export const selectWelcomeIsAdded = (state) => Boolean(state.welcome.id);
export const selectWelcomeId = (state) => state.welcome.id;
export const selectWelcomeUID = (state) => state.welcome.uid;
export const selectWelcomeSID = (state) => state.welcome.sid;

export const selectWelcomeBlockContent = (state) => state.welcome.blockContent;
export const selectWelcomeBlockDesign = (state) => state.welcome.blockDesign;

export const selectWelcomeItemDesign = (state) => state.welcome.itemDesign;
export const selectWelcomeContainerDesign = (state) => state.welcome.containerDesign;

export default welcomeSlice.reducer;
